import { useParams } from 'react-router-dom';
import { Navigation2 } from 'lucide-react';
import { BackHeader } from '@/components/BackHeader';
import { PAGES, type ContentBlock } from '@/content/pages';
import { openExternal } from '@/lib/tg';

export function PagePage() {
  const { slug } = useParams<{ slug: string }>();
  const page = slug ? PAGES[slug] : undefined;

  if (!page) {
    return (
      <div>
        <BackHeader title="404" />
        <p className="text-hint">Страница не найдена</p>
      </div>
    );
  }

  const isRouteCta = slug === 'parking';

  return (
    <div>
      <BackHeader title={page.title} />
      <article className="flex flex-col gap-4">
        {page.blocks.map((b, i) => (
          <Block key={i} block={b} />
        ))}
        {page.cta ? (
          isRouteCta ? (
            <button
              type="button"
              onClick={() => openExternal(page.cta!.url)}
              className="group relative mt-3 inline-flex items-center justify-center gap-3 overflow-hidden rounded-full px-5 py-3.5 font-semibold transition-transform active:scale-[0.98]"
              style={{
                background: '#ffffff',
                color: '#0a0a0b',
                boxShadow:
                  '0 0 0 1px rgba(255,255,255,0.85), 0 12px 28px -12px rgba(255,255,255,0.35), 0 0 30px -12px rgba(194,58,46,0.4)',
              }}
            >
              {/* Inner hairline sweep on press */}
              <span
                aria-hidden
                className="pointer-events-none absolute inset-0 opacity-0 transition-opacity group-active:opacity-100"
                style={{
                  background:
                    'radial-gradient(circle at center, rgba(0,0,0,0.12), transparent 60%)',
                }}
              />
              <span
                className="inline-flex items-center justify-center w-7 h-7 rounded-full"
                style={{ background: '#0a0a0b', color: '#ffffff' }}
              >
                <Navigation2 size={14} strokeWidth={2} className="-rotate-[38deg]" />
              </span>
              <span className="font-display text-[14px] tracking-[0.04em] uppercase">
                {page.cta.label}
              </span>
              <span aria-hidden className="font-mono text-[12px] opacity-60">
                ↗
              </span>
            </button>
          ) : (
            <button
              type="button"
              onClick={() => openExternal(page.cta!.url)}
              className="mt-3 inline-flex items-center justify-center rounded-full px-5 py-3 font-semibold uppercase tracking-[0.08em]"
              style={{
                background: '#ffffff',
                color: '#0a0a0b',
                boxShadow: '0 10px 24px -12px rgba(255,255,255,0.25)',
              }}
            >
              {page.cta.label}
            </button>
          )
        ) : null}
      </article>
    </div>
  );
}

function Block({ block }: { block: ContentBlock }) {
  switch (block.kind) {
    case 'heading':
      return (
        <div>
          <h2 className="headline text-[20px] uppercase tracking-[0.015em]">
            {block.text}
          </h2>
          <div className="hairline mt-2 w-10" />
        </div>
      );
    case 'paragraph':
      return (
        <p className="text-[14px] leading-[1.65] text-white/72">{block.text}</p>
      );
    case 'image':
      return (
        <img
          src={block.url}
          alt={block.alt ?? ''}
          className="w-full rounded-2xl object-cover"
          style={{ border: '1px solid var(--line-1)' }}
        />
      );
    default:
      return null;
  }
}
